import { lazyLoad } from "utils/loadable";

const BuildTestPage = lazyLoad(
  () => import("./index"),
  (module) => module.BuildTestPage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default BuildTestPage;
